// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","radio":"styles_radio__mq2CG","icon":"styles_icon__PTgZ8","container":"styles_container___S0rC","inline":"styles_inline__8qjyO"};